import type { XMediaPartialType } from '@/components/pages/content/types';

type InitialTweetAuthorProps = {
    post?: XMediaPartialType;
};

export const InitialTweetAuthor = ({ post }: InitialTweetAuthorProps) => {
    return (
        <div className="flex space-x-1 text-xs">
            <span className="font-GBold">{(post?.initial_author as { slug?: string })?.slug}</span>
            <a
                href={post?.initial_author?.permalink}
                rel="noopener noreferrer"
                target="_blank"
                className="text-icoBlue">
                {post?.initial_author?.tag}
            </a>
        </div>
    );
};
